import { GetClassiFicareTree } from '@/api'


export default {
  state: {
    tree: [], //所有菜单
    mcode: -1, //模版类型
    one: -1,
    oneTree: {},
    tow: 0,
    towTree: {},
    three: -1,
    threeTree: {},

    scode: 0,
  },
  mutations: {
    SET_tree(state, data) {
      state.tree = data
    },

    SET_scode(state, data) {
      state.scode = data
    },



    SET_Menu(state, param) {
      // debugger
      state.one = param.one;
      state.tow = param.tow;
      state.three = param.three;
      state.mcode = param.mcode;

      //不是首页
      if (param.one != -1) {

        state.oneTree = state.tree[param.one];

        state.towTree = state.tree[param.one].subs[param.tow];

        // console.log(state.towTree)
        if (param.three != -1) {


          state.threeTree = state.tree[param.one].subs[param.tow].subs[0];
        } else {
          state.three = -1;
          state.threeTree = {}
        }
      } else {
        state.mcode = -1;
        state.tow = 0;
        state.three = -1;

        state.oneTree = {};
        state.towTree = {};
        state.threeTree = {};
      }
    },
  },


  actions: {
    //获取所有菜单
    GetClassiFicareTree({ commit }) {
      return new Promise((resolve, reject) => {
        GetClassiFicareTree().then(res => {
          var clientWidth = document.documentElement.clientWidth;
          let num = 0;
          res.forEach((item, index) => {
            if (item.name == '招标采购')
              num = index
          });
          if (clientWidth < 1080) {
            res.splice(num, 1)
          }
          commit('SET_tree', res)
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },


  }
}



// WEBPACK FOOTER //
// ./src/store/module/user.js